export const API_HEALTH_PENDING = 'api_health_pending';
export const addApiHealthPending = () => ({ type: API_HEALTH_PENDING });

export const API_HEALTH_OK = 'api_health_ok';
export const addApiHealthOk = () => ({ type: API_HEALTH_OK });

export const API_HEALTH_ERROR = 'api_health_error';
export const addApiHealthError = () => ({ type: API_HEALTH_ERROR });
